<!--
=========================================================================================
    Message Card
==========================================================================================
-->

<template>
  <div>
    <div v-if="topic" class="mail__content mb-1 ">
      <TopicHeader :data="topic" :show-content="false" />
      <!-- MESSAGE TOPIC -->
      <div class="bubble _topic mail__content mt-2 z-10" v-html="topic.message"></div>

      <!-- MESSAGE REPLIES & RESPONDS -->
      <div class="vx-row">
        <div class="vx-col w-full overflow-hidden">
          <div v-if="loading">
            {{ $t('general.loading') }}
          </div>
          <div v-else class="message-pane mail__content break-words px-8 ">
            <template v-for="(message, index) in messages" >            
              <div
                :key="index"
                class="bubble mt-2 mb-3"
                :class="{ '_reply': message.data.isFromTeacher, '_response': message.data.isFromStudent }" >
                <!-- {{ index }}. {{ message }} -->
                <!-- {{ message }} -->
                <p v-html="message.data.message" />
                <!-- <vs-chip v-if="reply.isRead" transparent color="success" class="ml-2 my-auto" style="min-height: 20px;">
                  <span>READ {{ reply.readDate }}</span>
                </vs-chip>
                {{ reply.sendDate }} -->
              </div>

              <!-- <div v-if="index === messages.length - 1" ref="latest" :key="'_latest-' + index" /> -->
            </template>
            <div ref="latest" />
          </div>
          <div class="ps__rail-y ps--clicking" style="top: 8px; right: 0px; height: 553px;">
            <div class="ps__thumb-y" tabindex="0" style="top: 8px; height: 545px;"></div>
          </div>
        </div>
      </div>

      <!-- REPLY BOX -->
      <vx-card v-if="checkReplyable()" class="">
        <!-- :title="$t('pm.reply')"> -->
        <!-- <div class="vx-row">
          <div class="vx-col w-full flex flex-inline justify-end">
            <vs-button disabled small type="filled" class="m0 ml-2" color="lightgrey" icon="edit2">Plain Text</vs-button>
            <vs-button disabled small type="filled" class="m0 ml-3" color="lightgrey" icon="code">Editor</vs-button>
          </div>
        </div> -->

        <div class="vx-row">
          <div  class="vx-col w-full flex justify-between p-1 bg-white" >
            <vs-input
              class="flex-1"
              :placeholder="$t('pm.reply')"
              v-model="replyInput.content"
              @keyup.enter="sendReply"
            />
            <vs-button
              type="gradient" 
              class="bg-primary-gradient ml-4"
              @click="sendReply">
                {{ $t('general.message.send') }}
            </vs-button>
          </div>
        </div>
      </vx-card>

      <vx-card
        v-else 
        class="mt-8 text-white bg-danger" 
      >
        {{ $t('general.message.unable-reply') }}

      </vx-card>
      <!-- {{ message }} -->
    </div>
  </div>
</template>

<script>
import { state } from "../../data";
import { getAvatarUrl } from "@/utils/upload";
import PrivateMessageReply from '@/store/modules/private-message-reply/index';

const { Datastore } = state;

export default {
  components: {
    TopicHeader: () => import("./TopicHeader")
  },
  props: {
    data: {
      type: Object,
      default: null
    },
    
    // classSection: {},
    // 'courseOutlineRegistration': {},
  },
  data() {
    return {
      localData: state.local,
      replyInput: {
        content: ""
      },
      messages: [],
      loading: true,
    }
  },
  watch: {
    'topic': {
      handler(topic, prevTopic) {
        // console.log(this, topic, prevTopic);
        if (topic.id !== prevTopic.id) {
          this.checkMessageUpdate(topic)
        }
      },
      deep: true
    }
    //   'data': {
    //     handler: topic => {
    //       console.log(topic);
    //       if (topic) {
    //         // this.messages = topic.privateMessageReplies;
    //         this.loading = false;
    //       }
    //     },
    //     deep: true
    //   }
  },
  computed: {
    userPhoto() {
      if (this.topic && this.topic.fromUser) {
        return getAvatarUrl(this.topic.fromUser.photo)
      }
      return ''
    },
    userName() {
      if (this.topic && this.topic.fromUser) {
        return `${this.topic.fromUser.code} ${this.topic.fromUser.nameLocal} ${this.topic.fromUser.surnameLocal}`
      }
      return ''
    },
    courseName() {
      if (this.courseOutlineRegistration && this.classSection) {
        return `${this.courseOutlineRegistration.subjectCode} ${this.$t('pm.section-no')} ${this.classSection.sectionNo}`
      }
      return ''
    },
    topic() {
      return this.dataAdapter(this.data);
    }
  },
  methods: {
    dataAdapter(data) {
      const { id, topic, sendDate, readDate, fromUser, fromUserCode } = data;
      const sender_name = 
        `${fromUser ? fromUser.nameLocal : "" }
          ${fromUser ? fromUser.surnameLocal : "" }`;
      const sender_code = 
        `${fromUserCode ? fromUserCode : ""}`
      return {
        ...data,
        id,
        type: "pm",
        subject: topic,
        senderUUID: fromUser ? fromUser.photo : null,
        sender_name,                          
        sender_code,                          
        unread: readDate ? false : true,      
        time: sendDate,                       
        isStarred: true,                      
        content: data.message                 
      }                                       
    },
    async checkMessageUpdate(topic) {
      // Send topic id with checksum to server
      // Commit and cache return messages if exist.
      Datastore.Message.checkUpdate("pm", "topic", topic);
      this.messageLoader(topic);
      this.refreshMessages(topic);
    },                                   
    handlePMReplyEvent(data) {                
      // console.log("Check", Datastore.Message, data);
      // Save new PM message to Message Pool  
      Datastore.Message.save("message", "pm", data.id, { ...data });
      this.messages.push(data);               
      // Store Reply Message to Flatmap       
      // Add Reply Message to Topic           
      // Refresh This Page to show new message
    },                                        
    checkReplyable() {                        
      if (this.topic.fromUser || this.topic.fromUser !== null) {
        return true;                          
      }                                       
      return false;                           
    },                          
    async sendReply() {                       
      // BUGS: Message was sent to somebody else.
      // FIX: Wrong Logic for target user.
      const toUser = this.topic.fromUser; 

      console.log("sendReply from", this.$currentUser, "to", this.topic);
                                              
      const payload = {          
        fromUser: {
          uuid: this.$currentUser.uuid,
        },
        privateMessageId: this.topic.id,      
        toUserId: toUser.id,                  
        privateMessageReplyInput: {           
          toUserCode: toUser.code,            
          message: this.replyInput.content,                 
          isFromTeacher: true,                              
          isFromStudent: false,                             
        },                                                  
      }                
      
      console.log(payload);
                                                            
      let result = await this.$store.dispatch('PrivateMessageReply/addPrivateMessageReply', payload);
                                                            
      console.log(result);                                  
      // if (result) {                                      
      //   //   result = JSON.parse(JSON.stringify(result));
      //   //   this.$emit('updateDateAfterReply', result); 
      // }                                                  
    },                                                      
    async messageLoader(topic) {                            
      if (!topic) { return }                                
                                                            
      // User Reply List to Load Message from Datastore                                                   
      // TODO: Implement Load Limiter to limit total message to process                                   
      // (by chunking of descendant 10-20 items at a time)                                                
                                                                                                          
      // console.log("messageLoader", topic);                                                             
      // console.log("Map to Array Test", Datastore.Message);                                             
                                                                                                          
      // this.messages = topic.privateMessageReplies;                                                     
      console.log("Message Loader", topic);
      const messages = topic.privateMessageReplies                                                        
        .map(async _message => await Datastore.Message.load("message", "pm", _message.id, topic) || null);
                                                                                                          
      this.messages = (await Promise.all(messages))                                                       
        .filter(_message => {                                                                             
          return _message !== null;                                                                       
        });                                                                                               
                                                                                                          
    },
    markMesssageIsRead() {
      // TODO:
      // Send read signal to server
      // Mutate read status on client.
    },
    scrollToLatestMessage() {
      this.$nextTick(() => {
        if (this.$refs.latest) {
          this.$refs.latest.scrollIntoView();
        }
        this.markMesssageIsRead();
      });
    },
    refreshMessages(_data) {
      this.loading = true;
      this.messages = [];

      const data = _data.data || _data; // Fail proof

      this.messageLoader(data).then(() =>{                                                           
        this.loading = false;
        this.scrollToLatestMessage();
      });
    },
    checkCurrentMessageList() {
      // Check current message list from cache
      //   Memory store (Flatmap) then Browser db (Indexed DB)
      // Get last check timestamp (if load from flatmap)
      // Get checksum
      // Get total message
      // Get state (Total displaying message and cursor)
      // Logically check timestamp to recheck from server
      //   Send checksum string to server to compare if new data exist
      // Get data back from server / or Not (Skip next steps)
      // Set data into cache (both memory store and browser db)
      // Create list of message and commit to state
      //   Load or refresh message from cache to component
      console.log("checkCurrentMessageList() => prop: this.topic", this.topic);
      this.checkMessageUpdate(this.topic);
    }                 
  },                                                                  
  async mounted() {
    // this.checkMessageUpdate(this.topic);
    this.checkCurrentMessageList();

    this.$context.eventbus.$on("pm-reply", this.handlePMReplyEvent);
    this.$context.eventbus.$on("new-message", this.refreshMessages);
  },
  beforeCreate() {            
    if (!this.$store.state.PrivateMessageReply) { this.$store.registerModule("PrivateMessageReply", PrivateMessageReply) }
  },                         
  destroyed() {
    this.$store.unregisterModule("PrivateMessageReply");                   
  },              
}                                                                                                         
                                                                                                          
/* Functional                                                                                             
export default {                                                                                          
  inject: {                                                                                               
    components: {                                                                                         
      default: {                                                                                          
        PMUI: () => import("@/views/pages/PM/Components/PrivateMessageView")                              
      }                                                                                                   
    }                                                                                                     
  },                                                                                                      
  props: {                                                                                                
    message: {                                                                                            
      type: Object,                                                                                       
      required: true                                                                                      
    },                                                                                                    
    parentEl: {                                                                                           
      type: String                                                                                        
    }                                                                                                     
  }                                                                                                       
}                                                                                                         
*/                                                                                                        
</script>                                                                                                 
                                                                                                          
<style lang="scss" scoped>          

.message-pane {
  max-height: 30vh;
  overflow-y: scroll;
  overflow-x: hidden;
}

.bubble {                                                                                                 
	position: relative;                                                                                      
	max-width: 28em;                                                                                         
          
  width: fit-content;                                                                                                
	background-color: #fff;                                                                                  
	padding: 0.8rem 1rem;                                                                                  
  font-size: 1rem;                                                                                      
  border-radius: 12px;                                                                                    
  box-shadow: 0 0.125rem 0.1rem rgba(0, 0, 0, 0.2), 0 0.0625rem 0.125rem rgba(0, 0, 0, 0.2);              
                                                                                                          
  &._topic {                                                                                              
    box-shadow: 0 0.0625rem 0.125rem rgba(0, 0, 0, 0.2), 0 0.125rem 0.1rem rgba(0, 0, 0, 0.2);            
    background: #fafafa;                                                                                  
    max-width: 100% !important;     

    min-width: 70% !important;                                                                      
                                                                                                          
    ::before {                                                                                            
      // layout                                                                                           
      content: '';                                                                                        
      position: absolute;                                                                                 
      width: 0;                                                                                           
      height: 0;                                                                                          
      bottom: 96%;                                                                                        
      left: 1.2em; // offset should move with padding of parent                                           
      border: .75rem solid transparent;                                                                   
      border-top: none;                                                                                   
                                                                                                          
      // looks                                                                                            
      // background: #fafafa;                                                                             
      border-bottom-color: #f7f7f7;                                                                       
      // filter: drop-shadow(0 -1px 1px rgba(0, 0, 0, 0.05));

    filter: drop-shadow(0 -0.025rem 0.0125rem rgba(0, 0, 0, 0.1));
                                                      
    }                                                                                                     
  }                                                                                                       
                                                                                                          
  &._reply {                                                                                              
                                                                                                          
    margin-left: auto;                                                                                    
    text-align: right;                                                                                    
                                                                                                          
    &::before {                                                                                           
      // layout                                                                                           
      content: '';                                                                                        
      position: absolute;                                                                                 
      width: 0;                                                                                           
      height: 0;                                                                                          
      bottom: 35%;                                                                                        
      right: -1.1rem; // offset should move with padding of parent                                        
      border: .75rem solid transparent;                                                                   
      border-top: none;                                                                                   
                                                                                                          
      // looks                                                                                            
      border-bottom-color: #fff;                                                                          
      filter: drop-shadow(0 -0.0625rem 0.0625rem rgba(0, 0, 0, .2));                                      
      transform: rotate(90deg);                                                                           
    }                                                                                                     
  }                                                                                                       
                                                                                                          
  &._response {                                                                                           
                                                                                                          
    &::before {                                                                                           
      // layout                                                                                           
      content: '';                                                                                        
      position: absolute;                                                                                 
      width: 0;                                                                                           
      height: 0;                                                                                          
      bottom: 40%;                                                                                        
      left: -1rem; // offset should move with padding of parent                                           
      border: .75rem solid transparent;                                                                   
      border-top: none;                                                                                   
                                                                                                          
      // looks                                                                                            
      border-bottom-color: #fff;                                                                          
      filter: drop-shadow(0 -0.0625rem 0.0625rem rgba(0, 0, 0, 0.2));                                     
      transform: rotate(-90deg);                                                                          
    }                                                                                                     
  }                                                                                                       
}                                                                                                         
                                                                                                          
                                                                                                          
</style>                                                                                                  